export default __webpack_public_path__ + "static/media/Astro_Aries_Black.d76dc9db.png";